<h2 class="property-header">Propriétés de l'étape</h2>
<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Id</mat-label>
            <input matInput type="text" formControlName="id" autocomplete="off" tabindex="1" readonly="true" />
        </mat-form-field>
    </div>

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Nom</mat-label>
            <input matInput type="text" formControlName="stepName" autocomplete="off" required tabindex="2" />
            @if (dataForm.errors && dataForm.errors['stepName']?.required && (dataForm.controls['stepName']?.dirty || dataForm.controls['stepName'].touched)) {
                <mat-error>Le champ 'Nom' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Name" matTooltipPosition="left"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Durée maximale</mat-label>
            <app-time-duration-input formControlName="maxDuration" autocomplete="off" tabindex="3" />
            @if (dataForm.get('maxDuration').hasError('required')) {
                <mat-error>Le champ 'Durée maximale' est obligatoire.</mat-error>
            }
            @if (dataForm.get('maxDuration').hasError('format')) {
                <mat-error>La valeur ne respecte pas le format.</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="maxDurationTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
    </div>
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etats</mat-label>
            <app-step-states-control formControlName="states" [isStateDeletionAllowed]="isStateDeletionAllowed.bind(this)" required tabindex="4" />
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etats" matTooltipPosition="left"></fa-icon>
    </div>
</form>
